export enum ALARM_MESSAGE_STATE {
  ERROR = 'error',
  ACTIVE = 'active',
  USER_CANCELED = 'user_canceled',
  INVALID_PIN = 'invalid_pin'
}
